/* ============================================================
   LA FABRIQUE DES MINIS — volet panier
   Rendu côté client depuis /cart.js, deux groupes (ponctuel /
   abonnement), jauge de franco, édition des quantités.
   Le groupe d'une ligne est donné par son plan de vente Shopify
   (selling_plan_allocation) : c'est lui qui déclenche
   la génération automatique des commandes mensuelles.
   Le kit d'essai (ligne portant la propriété _kit) est verrouillé :
   une seule ligne, quantité figée à 1.
   ============================================================ */
(function () {
  'use strict';

  var PANEL = document.getElementById('lfdmCart');
  if (!PANEL) return;

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var R = window.routes || {};
  var URL_CART   = R.cart_url ? R.cart_url + '.js' : '/cart.js';
  var URL_ADD    = R.cart_add_url ? R.cart_add_url + '.js' : '/cart/add.js';
  var URL_CHANGE = R.cart_change_url ? R.cart_change_url + '.js' : '/cart/change.js';

  var CFG = {
    relay: parseInt(PANEL.getAttribute('data-free-relay'), 10) || 0,
    home:  parseInt(PANEL.getAttribute('data-free-home'), 10) || 0,
    labOne: PANEL.getAttribute('data-lab-one') || 'Une seule fois',
    labSub: PANEL.getAttribute('data-lab-sub') || 'Abonnement',
    noteSub: PANEL.getAttribute('data-note-sub') || '',
    cartUrl: PANEL.getAttribute('data-cart-url') || '/cart'
  };

  var BODY = $('[data-cp-body]', PANEL);
  var FOOT = $('[data-cp-foot]', PANEL);
  var SHIP = $('[data-cp-ship]', PANEL);
  var busy = false;
  var cart = null;

  /* ---------- utilitaires ---------- */
  function eur(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
  function plural(n, one, many) { return n + ' ' + (n > 1 ? many : one); }
  function toast(t) { if (window.LFDM && LFDM.toast) LFDM.toast(t); }

  function post(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Erreur panier');
        return j;
      });
    });
  }

  /* ---------- kit d'essai : un seul, quantité 1 ---------- */
  function isKit(it) { return !!(it && it.properties && it.properties._kit); }

  function kitLines(j) {
    var out = [];
    ((j && j.items) || []).forEach(function (it) { if (isKit(it)) out.push(it); });
    return out;
  }

  /* corrige le panier si un kit a été dupliqué ou sa quantité forcée
     (page /cart, retour en arrière, ancien panier…) */
  function enforceKit(j) {
    var kits = kitLines(j);
    if (!kits.length) return Promise.resolve(j);
    var keep = kits[kits.length - 1];
    var fixes = [];
    kits.forEach(function (it) { if (it !== keep) fixes.push({ id: it.key, quantity: 0 }); });
    if (keep.quantity > 1) fixes.push({ id: keep.key, quantity: 1 });
    if (!fixes.length) return Promise.resolve(j);
    var chain = Promise.resolve(j);
    fixes.forEach(function (f) {
      chain = chain.then(function () { return post(URL_CHANGE, f); });
    });
    return chain.then(function (res) {
      toast('Le kit d\'essai est limité à un par compte.');
      /* sur la page panier complète, l'affichage serveur est périmé */
      if (/^\/cart(\/|$)/.test(window.location.pathname)) window.location.reload();
      return res;
    }).catch(function () { return j; });
  }

  /* retire le kit présent dans le panier (changement de gamme ou de taille) */
  var kitClear = function () {
    return fetch(URL_CART, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var kits = kitLines(j);
        if (!kits.length) return j;
        var chain = Promise.resolve(j);
        kits.forEach(function (it) {
          chain = chain.then(function () { return post(URL_CHANGE, { id: it.key, quantity: 0 }); });
        });
        return chain;
      })
      .catch(function () {});
  };

  /* ---------- ouverture / fermeture ---------- */
  function lock(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  function open() {
    if (window.LFDM) { if (LFDM.closeMega) LFDM.closeMega(true); if (LFDM.closeDrawer) LFDM.closeDrawer(); }
    PANEL.classList.add('is-open');
    lock(true);
    var c = $('.cp-close', PANEL);
    if (c) c.focus({ preventScroll: true });
  }
  function close() { PANEL.classList.remove('is-open'); lock(false); }

  window.LFDM = window.LFDM || {};
  LFDM.openCart = function () { open(); refresh(); };
  LFDM.closeCart = close;
  LFDM.kitClear = kitClear;

  /* ---------- badge de l'en-tête ---------- */
  function badge(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  /* ---------- jauge de franco ---------- */
  function gauge(total) {
    if (!SHIP || !CFG.home) return;
    var bar = $('.cp-bar i', SHIP);
    var msg = $('[data-cp-msg]', SHIP);
    var tick = $('.cp-tick', SHIP);

    if (!total) { SHIP.setAttribute('hidden', ''); return; }
    SHIP.removeAttribute('hidden');

    var pct = Math.min(100, Math.round(total / CFG.home * 100));
    if (bar) {
      bar.style.width = pct + '%';
      bar.classList.toggle('full', total >= CFG.home);
    }
    if (tick) tick.style.left = Math.round(CFG.relay / CFG.home * 100) + '%';

    var txt;
    if (total >= CFG.home) {
      txt = '<b>Livraison offerte</b>, en point relais comme à domicile.';
    } else if (total >= CFG.relay) {
      txt = '<b>Livraison offerte</b> en point relais. Encore <b>' +
            eur(CFG.home - total) + '</b> pour la livraison offerte à domicile.';
    } else {
      txt = 'Encore <b>' + eur(CFG.relay - total) +
            '</b> pour la livraison offerte en point relais.';
    }
    if (msg) msg.innerHTML = txt;
  }

  /* ---------- une ligne ---------- */
  function lineHtml(it) {
    var free = it.line_price === 0;
    var kit = isKit(it);
    var thumb = it.image
      ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2')) +
        '" alt="" width="64" height="64" loading="lazy">'
      : '<svg aria-hidden="true"><use href="#i-box"></use></svg>';

    /* variante + propriétés publiques */
    var bits = [];
    if (it.options_with_values) {
      it.options_with_values.forEach(function (o) {
        if (o.value && o.value !== 'Default Title') bits.push(esc(o.name) + ' ' + esc(o.value));
      });
    }
    if (it.properties) {
      Object.keys(it.properties).forEach(function (k) {
        if (k.charAt(0) !== '_' && it.properties[k]) bits.push(esc(k) + ' : ' + esc(it.properties[k]));
      });
    }

    var unit = it.quantity > 1 ? '<small>' + eur(it.final_price) + ' l\'unité</small>' : '';

    /* le kit n'est pas modifiable en quantité */
    var qtyHtml = kit
      ? '<span class="cp-fix" style="font-size:12px;line-height:1.3;opacity:.72">' +
          'Quantité 1 · limité à un par compte</span>'
      : '<div class="cp-qty">' +
          '<button type="button" data-cp-step="-1" aria-label="Retirer un exemplaire"' +
            (it.quantity <= 1 ? ' disabled' : '') +
            '><svg aria-hidden="true"><use href="#i-minus"></use></svg></button>' +
          '<b>' + it.quantity + '</b>' +
          '<button type="button" data-cp-step="1" aria-label="Ajouter un exemplaire">' +
            '<svg aria-hidden="true"><use href="#i-plus"></use></svg></button>' +
        '</div>';

    return '' +
      '<div class="cp-line" data-key="' + esc(it.key) + '">' +
        '<div class="cp-thumb' + (free ? ' free' : '') + '">' + thumb + '</div>' +
        '<div>' +
          '<div class="cp-l-top">' +
            '<a class="cp-name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
            '<span class="cp-price' + (free ? ' free' : '') + '">' +
              (free ? 'Offert' : eur(it.line_price)) + unit +
            '</span>' +
          '</div>' +
          (bits.length ? '<p class="cp-meta">' + bits.join(' · ') + '</p>' : '') +
          '<div class="cp-l-bot">' +
            qtyHtml +
            '<button class="cp-del" type="button" data-cp-del aria-label="Retirer cet article">' +
              '<svg aria-hidden="true"><use href="#i-trash"></use></svg></button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  /* ---------- un groupe ---------- */
  function groupHtml(plan, items, note) {
    var qty = 0, sum = 0;
    items.forEach(function (i) { qty += i.quantity; sum += i.line_price; });

    return '' +
      '<div class="cp-group" data-plan="' + plan + '">' +
        '<div class="cp-g-head">' +
          '<b>' + esc(plan === 'sub' ? CFG.labSub : CFG.labOne) +
            ' <small>' + plural(qty, 'article', 'articles') + '</small></b>' +
          '<span class="cp-g-t"><span>Sous-total</span><em>' + eur(sum) + '</em></span>' +
        '</div>' +
        (note ? '<p class="cp-g-note"><svg aria-hidden="true"><use href="#i-repeat"></use></svg>' +
                esc(note) + '</p>' : '') +
        items.map(lineHtml).join('') +
      '</div>';
  }

  /* ---------- rendu complet ---------- */
  function render() {
    if (!cart) return;
    var items = (cart.items || []).slice().reverse();   /* plus récent en premier */
    badge(cart.item_count);

    var sub = $('[data-cp-sub]', PANEL);
    if (sub) sub.textContent = cart.item_count ? plural(cart.item_count, 'article', 'articles') : '';

    if (!items.length) {
      BODY.innerHTML =
        '<div class="cp-empty">' +
          '<span class="ic"><svg aria-hidden="true"><use href="#i-cart"></use></svg></span>' +
          '<b>Votre panier est vide</b>' +
          '<p>Le kit d\'essai est offert, il ne reste que les frais de port.</p>' +
          '<a class="btn btn-primary" href="/collections/couches">Voir les couches</a>' +
        '</div>';
      FOOT.setAttribute('hidden', '');
      gauge(0);
      return;
    }

    var one = [], subs = [];
    items.forEach(function (it) {
      if (it.selling_plan_allocation) subs.push(it); else one.push(it);
    });

    var html = '';
    if (one.length)  html += groupHtml('one', one, '');
    if (subs.length) html += groupHtml('sub', subs, CFG.noteSub);
    BODY.innerHTML = html;

    var subTotal = 0;
    subs.forEach(function (i) { subTotal += i.line_price; });

    FOOT.removeAttribute('hidden');
    $('[data-cp-total]', PANEL).textContent = eur(cart.items_subtotal_price);
    var srow = $('[data-cp-subrow]', PANEL);
    if (subs.length) {
      srow.removeAttribute('hidden');
      $('[data-cp-subtotal]', PANEL).textContent = eur(subTotal);
    } else {
      srow.setAttribute('hidden', '');
    }

    gauge(cart.items_subtotal_price);
  }

  /* ---------- lecture / écriture ---------- */
  function refresh() {
    return fetch(URL_CART, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { return enforceKit(j); })
      .then(function (j) { cart = j; render(); return j; })
      .catch(function () {});
  }

  function change(key, qty) {
    if (busy) return;
    busy = true;
    PANEL.setAttribute('aria-busy', 'true');
    post(URL_CHANGE, { id: key, quantity: qty })
      .then(function (j) { cart = j; render(); })
      .catch(function (e) { toast(e.message); })
      .then(function () { busy = false; PANEL.removeAttribute('aria-busy'); });
  }

  /* ajout au panier, utilisé par la fiche produit et la page catégorie */
  /* Sur mobile, un ajout ne déploie pas le volet : seul le toast confirme. */
  function isNarrow() { return window.matchMedia('(max-width:999px)').matches; }

  LFDM.cartAdd = function (items, msg) {
    var list = Array.isArray(items) ? items : [items];
    /* le kit d'essai ne dépasse jamais 1 */
    list.forEach(function (it) {
      if (it && it.properties && it.properties._kit) it.quantity = 1;
    });
    return post(URL_ADD, { items: list })
      .then(function () { return refresh(); })
      .then(function () {
        if (!isNarrow()) open();
        toast(msg || 'Ajouté au panier');
      })
      .catch(function (e) { toast(e.message); throw e; });
  };
  LFDM.cartRefresh = refresh;

  /* ---------- événements ---------- */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) {
      e.preventDefault();
      /* sur mobile, l'icône panier mène à la page panier complète */
      if (isNarrow()) { window.location.href = CFG.cartUrl; return; }
      LFDM.openCart();
      return;
    }

    if (!PANEL.classList.contains('is-open')) return;

    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); return; }

    var line = e.target.closest('.cp-line');
    if (!line) return;
    var key = line.getAttribute('data-key');

    var del = e.target.closest('[data-cp-del]');
    if (del) { change(key, 0); return; }

    var step = e.target.closest('[data-cp-step]');
    if (step) {
      var cur = parseInt($('.cp-qty b', line).textContent, 10) || 1;
      var next = cur + parseInt(step.getAttribute('data-cp-step'), 10);
      if (next < 1) next = 1;
      change(key, next);
    }
  });

  /* les formulaires d'ajout natifs passent aussi par le volet */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    if (form.hasAttribute('data-no-ajax')) return;
    var id = form.querySelector('[name="id"]');
    if (!id || !id.value) return;
    e.preventDefault();
    var qty = form.querySelector('[name="quantity"]');
    var plan = form.querySelector('[name="selling_plan"]');
    var item = { id: id.value, quantity: qty ? parseInt(qty.value, 10) || 1 : 1 };
    if (plan && plan.value) item.selling_plan = plan.value;
    LFDM.cartAdd(item);
  });

  refresh();
})();
